export default "__VITE_ASSET__e70024b5__"